import $ from 'jquery';

export default class TemplateListCollections {
  constructor({ el }) {
    this.$el = $(el);
    this.validate();
  }

  validate() {
    if ($('html').hasClass('lt-ie9')) {
      this.verticallyAlignDetails();
    }
  }

  verticallyAlignDetails() {
    $('.collections-list', this.$el).imagesLoaded(() => (() => {
      const result = [];
      $('.collection-item', this.$el).each((index, collection) => {
        const collectionsDetails = $(collection).find('.collection-item-details');
        const collectionDetailsHeight = collectionsDetails.height();

        result.push(collectionsDetails.css({ marginTop: -(collectionDetailsHeight / 2) }));
      });
      return result;
    })());
  }
}
